import { Pipe, PipeTransform } from '@angular/core';
import { NgxExcelSelectOption } from '../models/models';
import { isArray } from 'util';

@Pipe({
  name: 'ngxExcelMultiItem'
})

export class NgxExcelMultiItemPipe implements PipeTransform {

  /**
   * æ¾ç¤ºåé¡¹æå¤é¡¹åè¡¨
   * @param value å¯¹è±¡æå¯¹è±¡åè¡¨
   * @param label æ ç­¾
   * @param count æå¤æ¸²æçå¯¹è±¡æ°é
   */
  transform(value: any, label?: string, count?: number): string {
    return Array.isArray(value) ?
      this._transformMultiItem(value, label || 'label', count) :
      this._transformSingleItem(value, label || 'label');
  }

  private _transformMultiItem(value: any[], label: string, count?: number): string {
    const n = value.length;
    const i = count || n;
    let resultStr = value.slice(0, i).map((item) => item[label] || '').join('ï¼');
    if (i < n) {
      resultStr += ` ç­ ${n} é¡¹`;
    }
    return resultStr;
  }

  private _transformSingleItem(value: any, label: string): string {
    return value[label] || '';
  }
}
